import React, { useEffect, useState, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { useNavigate, useLocation } from "react-router-dom";
import PostStyle1 from "../Components/PostStyle1";
import "../style.css";

const YouMayAlsoLike = ({ currentPostId }) => {
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 450);

  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });
  const navigate = useNavigate();
  const location = useLocation();

  // Function to shuffle an array
  const shuffleArray = (array) => {
    return array
      .map((item) => ({ item, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ item }) => item);
  };

  // Fetch related posts
  useEffect(() => {
    const fetchRelatedPosts = async () => {
      try {
        const response = await fetch("https://xebrand.in/Backend/get_data.php");
        const data = await response.json();

        if (data.success) {
          const filteredPosts = data.data.filter(
            (post) => post.status === "Active" && post.id !== currentPostId
          );

          const shuffledPosts = shuffleArray(filteredPosts).slice(0, 3);
          setRelatedPosts(shuffledPosts);
        } else {
          setError(data.message || "Failed to fetch related posts.");
        }
      } catch (err) {
        console.error("Error fetching related posts:", err);
        setError("An error occurred while fetching related posts.");
      } finally {
        setLoading(false);
      }
    };

    fetchRelatedPosts();
  }, [currentPostId]);

  // Handle viewport resizing for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 450);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  const handlePostClick = (postSlug) => {
    navigate(`/Shopify-custom-sections/post/${postSlug}`);
  };

  if (loading || error || relatedPosts.length === 0) {
    return null; // Don't render if loading, error, or no related posts
  }

  return (
    <div className="you-may-also-like-section">
      <h2>You May Also Like</h2>

      {isMobile ? (
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {relatedPosts.map((post) => (
              <div className="embla__slide" key={post.id}>
                <PostStyle1
                  block={post}
                  viewMode="Cards"
                  onClick={() => handlePostClick(post.slug)}
                />
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="related-posts-grid">
          {relatedPosts.map((post) => (
            <PostStyle1
              key={post.id}
              block={post}
              viewMode="Cards"
              onClick={() => handlePostClick(post.slug)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default YouMayAlsoLike;
